export default "__VITE_ASSET__M5wZQxj4__"